import {useSelector} from 'react-redux';
import {selectedPresentationSelector} from '../../store/selectors/presentation.selectors';
import {ISlide} from '../../incase-domain/slide';
import {isSlideUsedInAppliedRules} from '../../utils/rule';

export const useRules = (): {
    checkIfElementIsUsedInAppliedRules: (elementId: string) => boolean;
    checkIfSlideIsUsedInAppliedRules: (slide: ISlide) => boolean;
} => {
    const {appliedRules} = useSelector(selectedPresentationSelector);

    const checkIfElementIsUsedInAppliedRules = (elementId: string): boolean => {
        if (!appliedRules) return false;
        return appliedRules.some((rule) => {
            return rule.predicates.some((predicate) => {
                return predicate.elementId === elementId;
            });
        });
    };

    const checkIfSlideIsUsedInAppliedRules = (slide: ISlide): boolean => isSlideUsedInAppliedRules(slide, appliedRules);

    return {checkIfElementIsUsedInAppliedRules, checkIfSlideIsUsedInAppliedRules};
};
